import styled from 'styled-components';

import {CheckBox} from './../../common/CheckBox/CheckBox';

export const StyledCheckBox = styled(CheckBox)(
  props => `
  height: 1.3rem;
  width: 1.3rem;
  margin-top: ${props.theme.spacing.custom(3)};
`,
);

export const FontBoldSpan = styled.span`
  font-weight: 600;
`;

export const FontBigBold = styled.span(
  props => `
  font-size: ${props.theme.font.custom(14)};
`,
);

export const WrapperSpan = styled.span(
  props => `
padding: 0 ${props.theme.spacing.small};
`,
);

export const HiddenDropdownWrapperDiv = styled.div(
  props => `
  width: 20rem;
  max-width: 30rem;
  z-index: ${props.theme.misc.zIndex.base};
  visibility: hidden;
  transition: opacity 0.8s;
  padding: ${props.theme.spacing.base} 0;
  position:absolute;
  top: 1rem;
  right: 0;
  //left: 0;
`,
);

export const HoverTargetWrapperDiv = styled.div(
  props => `
  position: relative;
  text-align: left;
  display: inline-flex;
  align-self: flex-start;
  font-size: ${props.theme.font.custom(14)};
  cursor: pointer;
  &:hover > ${HiddenDropdownWrapperDiv} {
    visibility: visible;
  }
`,
);

export const TopDiv = styled.div(
  props => `
background-color: ${props.theme.colors.goWhite.base};
border-radius: ${props.theme.misc.borderRadius.base};
box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.base
  };
`,
);

const TipUI = styled.div(
  props => `
  position: absolute;
  margin-left: -${props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &:: after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
  }
`,
);

export const TipPositioning = styled(TipUI)(
  props => `
right: 15%;
top: -0.1rem;
&::after {
  transform: translate(-50%, 50%) rotate(45deg);
  background-color: ${props.theme.colors.goWhite.base};
  box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)}
    ${props.theme.colors.shadow.base};
}
`,
);

export const SortingDropDownWrapper = styled.div(
  props => `
width: 100%;
display: flex;
list-style-type: none;
overflow: hidden;
padding: ${props.theme.spacing.small} 0 0;
flex-direction: column;
> li {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding: ${props.theme.spacing.base};
  position: relative;
  &:last-child {
    border-bottom: none;
  }
}
`,
);

export const RadioCheck = styled.input.attrs({type: 'radio'})(
  props => `
  width: 2.2rem;
  // height: 2rem;
  align-items: center;
  justify-content: center;
  margin-right: ${props.theme.spacing.small};
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
  //margin-top: ${props.theme.spacing.custom(3)};
  &:checked{
      background-color: #e9ecee;
      border: 2px solid #adb8c0;
      color: #99a1a7;
      // padding: ${props.theme.spacing.base};
  }
  :checked:after {
      content: " ";
      // height: 1.4rem;
      height: 16px;
      position: absolute;
      // width: 1.4rem;
      width: 16px;
      top: 9px;
      left: 1.2rem;
      
  }
`,
);
